import {
  LMS_INIT_SUCCESS,
  LMS_INIT_REQUEST,
  LOAD_MORE_REQUEST,
  LOAD_MORE_SUCCESS,
  LOAD_MORE_FAILURE,
  FILTER_REQUEST,
  FILTER_REQUEST_SUCCESS,
  SORT_REQUEST,
  SORT_SUCCESS,
} from '../constants';

const initialAppState = {
  hasInitialized: false,
  isFetching: false,
  showLoading: false,
  texts: {},
  messages: [],
  pageInfo: {},
};

const appReducer = (state = initialAppState, action) => {
  const { type, payload = {} } = action;

  switch (type) {
    case FILTER_REQUEST:
    case LMS_INIT_REQUEST:
      return {
        ...state,
        isFetching: true,
        showLoading: true,
      };

    case LMS_INIT_SUCCESS:
      return {
        ...state,
        hasInitialized: true,
        isFetching: false,
        showLoading: false,
        messages: payload?.messages || state.messages,
        pageInfo: payload?.pageInfo,
      };

    case LOAD_MORE_REQUEST:
      return {
        ...state,
        isFetching: true,
      };

    case LOAD_MORE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        pageInfo: payload.pageInfo,
      };

    case LOAD_MORE_FAILURE:
      return {
        ...state,
        isFetching: false,
      };

    case FILTER_REQUEST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        showLoading: false,
        messages: payload?.messages || state.messages,
        pageInfo: payload.pageInfo,
      };

    case SORT_REQUEST:
      return {
        ...state,
        showLoading: true,
      };

    case SORT_SUCCESS:
      return {
        ...state,
        showLoading: false,
        messages: payload.messages,
        pageInfo: payload.pageInfo,
      };

    default:
      return state;
  }
};

export default appReducer;
